export enum OrderStatus {
    inProgress = "inProgress",
    declined = "declined",
    canceled = "canceled",
    completed = "completed",
    pending = "pending",
    failed = "failed"
}


export enum ComponentType {
    multiple = "multiple", // 0...n
    single = "single", // 0...1
}

export type TCurrency = {
    code: string;
    exponent: number;
}

export type TLocationCoordinate = {
    latitude: number;
    longitude: number;
}

export type TComponentItem = {
    name: string;
    optionDescription: string;
    price: number;
    value: number;
    maxValue: number;
    imagePath: string;
}

export type TComponentCategory = {
    name: string;
    isRequired: boolean;
    isBase: boolean;
    componentDescription: string;
    componentType: ComponentType;
    maxSelected: number;
    options: TComponentItem[];

    // items of original components
    isReusableComponent: boolean;
    menuId?: string; // id of associated RestaurantMenu (only for reusable)
    originalId?: string; // original component id
}

export type TMenuItem = {
    _id: string;
    name: string;
    comment: string;
    productDescription: string;
    imagePath: string;
    basePrice: number;
    orderCount: number;
    components: TComponentCategory[];
}

export type TMenuCategory = {
    _id: string
    categoryName: string;
    categoryImage: string;
    items: TMenuItem[];
    isCombined: boolean;
}

export type TDeliveryLocation = {
    coordinate: TLocationCoordinate;
    address: string;
    comment: string;
}

export type TWorkingHours = {
    isWorking: boolean;
    hours?: {
        opening: Date;
        closing: Date;
    }[]
}

export type TDeliveryArea = {
    name: string;
    minTotal: number;
    areaPolygon: TLocationCoordinate[];
}

export type TOrder = {
    _id?: string;
    status: OrderStatus;
    code: string;
    deadlineDate: Date;
    total: number;
    items: TMenuItem[];
    shippingMethod: ShippingMethod;
    paymentMethod: PaymentMethod;
    deliveryDate: Date;
    comment: string;
    createdAt: Date;
    deliveryLocation: TDeliveryLocation;
    dineInPlace?: string;
    feedback?: string;
}

export enum PaymentMethod {
    online = "online",
    cardInStore = "cardInStore",
    cashInStore = "cashInStore"
}

export enum ShippingMethod {
    delivery = "delivery",
    takeout = "takeout",
    dineIn = "dineIn"
}

export type TRestaurant = {
    _id: string;
    address: string;
    name: string;
    locationId: string;
    networkId: string;
    networkName: string;
    minTotal: number;
    maxTotal: number;
    minMinutesBeforeTakeout: number;
    minMinutesBeforeDelivery: number;
    phoneNumber: string;
    preferedLocale: string;
    isAvailable: boolean;
    imagePath?: string;
    timeZoneAbbr: string;
    restaurantLocation: TLocationCoordinate;
    deliveryAreas: TDeliveryArea[];
    currency: TCurrency;
    shippingMethods: ShippingMethod[];
    paymentMethods: PaymentMethod[];
}

export type TCustomer = {
    _id?: string;
    isActive?: boolean;
    name: string;
    phoneNumber: string;
    selectedRestaurant?: string;
    lastConfirmation?: Date;
    preferedLocale?: string;
    deliveryLocation?: TDeliveryLocation;
};

export type TServerError = {
    id: string,
    title: string,
    message: string,
}

export type TGeocodingResponse = {
    street: string,
    streetNumber: string,
    place: string,
    region: string,
    fullAddress: string,
    coordinate: TLocationCoordinate
}

export type TOrderFeedback = {
    customerFeedback: string;
    restaurantResponse: string;
    restaurantResponseTime: Date;
    rating: number;
    order: TOrder;
    customer: TCustomer;
    customerName: string;
    restaurant: TRestaurant;
    createdAt: Date;
}